import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_DESC =
    "BookBlend — curated book bags from vending machines near you. Grab a bag, scan the code, and join a community that reads.";

const PAGE_META = {
    "/": {
        title: "BookBlend — Curated Book Bags from Vending Machines Near You",
        description: DEFAULT_DESC,
    },
    "/membership": {
        title: "BookBlend Membership — Plus & Pro App Plans with 7-Day Free Trial",
        description:
            "Unlock the full BookBlend app: reading tracker, book clubs, community and more. Plus $9.99/mo or Pro $14.99/mo — both with a 7-day free trial.",
    },
    "/shop": {
        title: "The Bag Drop — This Month's Curated Book Bags | BookBlend",
        description:
            "See the curated book bags currently dropping in BookBlend vending machines: The Page Turner, The Plot Twist, The Whole Story, and The Book & Brew.",
    },
    "/find-a-machine": {
        title: "Find a BookBlend Book Vending Machine Near You",
        description:
            "See live BookBlend machine locations, get restock alerts, join the waitlist for your city — or bring a book vending machine to your café or office.",
    },
    "/blog": {
        title: "BookBlend — Curated Book Bags from Vending Machines Near You",
        description: DEFAULT_DESC,
    },
    "/support": {
        title: "Support & FAQ | BookBlend",
        description:
            "Get help with BookBlend memberships, machines, and the app. Answers to common questions and how to reach a real human.",
    },
    "/privacy-policy": {
        title: "Privacy Policy | BookBlend",
        description: "How BookBlend collects, uses, and protects your information.",
    },
    "/terms": {
        title: "Terms of Service | BookBlend",
        description: "The terms that govern your use of BookBlend's website, machines, and app.",
    },
    "/refund-and-shipping": {
        title: "Refunds & Machine Pickup Policy | BookBlend",
        description: "How refunds and machine purchases work at BookBlend.",
    },
};

const metaForPath = (pathname) => PAGE_META[pathname] || PAGE_META["/"];

const setTag = (selector, create, content) => {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = create();
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
    return el;
};

const setMetaByName = (name, content) =>
    setTag(`meta[name="${name}"]`, () => {
        const m = document.createElement("meta");
        m.setAttribute("name", name);
        return m;
    }, content);

const setMetaByProp = (prop, content) =>
    setTag(`meta[property="${prop}"]`, () => {
        const m = document.createElement("meta");
        m.setAttribute("property", prop);
        return m;
    }, content);

export const RouteSeo = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        if (pathname.startsWith("/admin")) {
            document.title = "BookBlend HQ";
            return;
        }
        const url = window.location.origin + pathname;
        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", url);
        setMetaByProp("og:url", url);
        setMetaByProp("og:type", "website");
        const { title, description } = metaForPath(pathname);
        document.title = title;
        setMetaByName("description", description);
        setMetaByProp("og:title", title);
        setMetaByProp("og:description", description);
    }, [pathname]);

    return null;
};
